import { attachPromise } from './attachPromise';
export const fromHttpPromise = (name, fetch) => ({
  name,
  tags: ['http', 'promise'],
  attach: (params, runtime) => attachPromise(() => fetch(runtime.env.httpClient, params), params, runtime, 'http')
});